<app-iota-modal i18n-title title="Manage employee groups" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body class="flex flex-col items-start gap-2">
        <button class="btn btn-accent gap-2" (click)="addNewSelectionDescription()">
            <iota-icon icon="plus"></iota-icon>
            <span i18n>New employee group</span>
        </button>
        <div class="spinner spinner-primary w-11" *ngIf="!loaded | ngrxPush"></div>
        <app-selection-description
            *ngFor="let selectionDescription of allSelectionDescriptions"
            [selectionDescription]="selectionDescription"
            (deleted)="deleteSelectionDescription($event)"
            #selectionDescriptions
        ></app-selection-description>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button modal-footer class="btn btn-primary" [ngClass]="{ loading: saveLoading }" (click)="onSaveClick()" i18n>Save</button>
    </div>
</app-iota-modal>
